import React from "react";
import { PaginatedResponse } from "src/types";

import { fetchAllFdroidRepos, FetchAllFdroidReposPayload } from "@admin/api/fdroid";

const defaultData: PaginatedResponse<API.FdroidRepoAdmin> = {
    list: [],
    count: 0,
    pageIndex: 0,
    pageSize: 12,
    message: "",
    details: [],
};

export const useGetAllFdroidRepos = (payload: FetchAllFdroidReposPayload) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    const [data, setData] = React.useState<PaginatedResponse<API.FdroidRepoAdmin>>(defaultData);
    const [refreshKey, setRefreshKey] = React.useState(0);

    React.useEffect(() => {
        const controller = new AbortController();
        setIsLoading(true);
        setIsError(false);
        fetchAllFdroidRepos(payload, controller.signal)
            .then((result) => {
                if (!controller.signal.aborted) {
                    setData(result);
                }
            })
            .catch(() => {
                if (!controller.signal.aborted) {
                    setIsError(true);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setIsLoading(false);
                }
            });
        return () => controller.abort();
        // `payload` is a fresh object on every render, so depend on its fields. Keep this list in step with
        // FetchAllFdroidReposPayload: the linter cannot check it here.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        payload.pageIndex,
        payload.pageSize,
        payload.sortCriteria,
        payload.sortDirection,
        payload.workspaceId,
        payload.name,
        payload.title,
        payload.url,
        refreshKey,
    ]);

    return { data, isLoading, isError, refetch: () => setRefreshKey((k) => k + 1) };
};
